import { Link } from 'react-router';
import { getTenantOptions, tenantApi } from '../../../APIs/tenants';
import { useAuth } from '../../../contexts/AuthContext';
import { useGet } from '../../../hooks/useApi';
import { Icon, Icons } from '../../atomic/icons';
import { columnDefiner, Table } from '../../atomic/table';
import { KintoneLogsModel } from '../../../models/TenantModel';
import { reformat } from '../../../utils/DateUtils';
import { useMemo, useState } from 'react';
import React from 'react';
import { Pager } from '../../folderview/Pager';
import { PAGER_LIMITS } from '../../../consts';
import { NumberField, SelectField } from '../../atomic/forms';
import { Loading } from '../../atomic/effects';

interface AppData extends KintoneLogsModel {
    trClass: string;
}

const definer = columnDefiner<AppData>();
const columns = [
    definer.accessor('appId', {
        header: 'アプリID',
        cell: (d: any) => {
            const { appId } = d.row.original;
            return <>{appId}</>;
        },
    }),
    {
        header: '日付',
        cell: (d: any) => {
            const { createdAt } = d.row.original;
            return <>{reformat(createdAt)}</>;
        },
    },
    {
        header: 'エラーコード',
        cell: (d: any) => {
            const { code } = d.row.original;
            return <>{code}</>;
        },
    },
    {
        header: 'メッセージ',
        cell: (d: any) => {
            const { messageJp } = d.row.original;
            return <>{messageJp}</>;
        },
    },
];

export type AdminKintoneLogsProp = {};
export const AdminKintoneLogs: React.FC<AdminKintoneLogsProp> = () => {
    const { user } = useAuth();
    const tenantId = React.useMemo(() => user?.tenantId, [user?.tenantId]);
    const [apps, setApps] = useState<
        { appId: string; appDescription: string }[]
    >([]);
    const [appId, setAppId] = useState<string | undefined>(undefined);
    const [page, setPage] = useState<number>(0);
    const [limit, setLimit] = useState<number>(PAGER_LIMITS[0]);
    const offset = useMemo(() => page * limit, [page, limit]);

    const request = useMemo(() => {
        if (!tenantId) return null;
        return tenantApi.get.getKintoneLogsForAdmin(
            tenantId,
            appId,
            offset,
            limit
        );
    }, [tenantId, appId, offset, limit]);
    const { data: logs } = useGet(request);

    React.useEffect(() => {
        if (tenantId) {
            getTenantOptions({
                tenantId: tenantId,
                category: 'kintone',
                keys: ['id'],
                array: ['apps'],
            })
                .then((resp: any) => {
                    if (resp.status === 'success') {
                        setApps(resp.data.kintone?.apps);
                    }
                })
                .catch((err) => {
                    console.warn(err);
                });
        }
    }, [tenantId]);

    const pager = React.useMemo(() => {
        if (logs && logs.pagination) {
            return (
                <Pager
                    pagination={logs.pagination}
                    setPage={setPage}
                    setLimit={setLimit}
                />
            );
        }
        return <></>;
    }, [logs]);

    const selectOptions = React.useMemo(() => {
        const options = apps.map((_app) => {
            return {
                text: `${_app.appId}:${_app.appDescription ?? ''}`,
                value: _app.appId.toString(),
            };
        });
        options.unshift({ text: '', value: '' });
        return options;
    }, [apps]);

    const options = {};
    return (
        <div className="app-main admin-kintone">
            <h2>Kintone連携ログ</h2>
            <div className="menu">
                <ul>
                    <li>
                        <Link to="/app/admin/kintone/apps">
                            <Icon icon={Icons.Config} />
                            Kintoneアプリ設定
                        </Link>
                    </li>
                </ul>
            </div>
            <div className="search">
                <SelectField
                    label="アプリID"
                    options={selectOptions}
                    _onChange={(value) => {
                        setAppId(value);
                        setPage(0);
                    }}
                    value={appId}
                />
            </div>
            {logs ? (
                <>
                    {pager}
                    <Table
                        data={logs.data}
                        columns={columns}
                        options={options}
                    />
                    {pager}
                </>
            ) : (
                <Loading />
            )}
        </div>
    );
};
